import React from "react";
import {
  Box,
  FormControl,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

/**
 * @param {string} value - 選択中の値
 * @param {function} onChange - 値変更時のコールバック
 * @param {{ value: string, label: string }[]} options - 選択肢リスト
 * @param {string} [label] - ラベル
 * @param {boolean} [isRequired] - 必須ラベルを表示するか
 * @param {string} [name] - name属性
 * @param {boolean} [error] - エラー表示にするか
 */
function ToggleButtonRadio({
  label = "",
  value,
  onChange,
  options = [],
  isRequired = false,
  name = "radio",
  error = false,
}) {
  return (
    <FormControl component="fieldset" fullWidth error={error}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={(e, newValue) => {
          if (newValue !== null) {
            onChange({ target: { name, value: newValue } });
          }
        }}
        fullWidth
      >
        {options.map((opt) => (
          <ToggleButton key={opt.value} value={opt.value} color="primary">
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
}

export default ToggleButtonRadio;
